import { route, tag, type PageTour } from '../pageTour';

export const integrationsTour: PageTour = {
  id: 'page-integrations',
  version: 1,
  title: 'Integrations',
  summary: 'Connect outside VMS and analytics systems.',
  match: route('/settings/integrations'),
  steps: [
    {
      target: tag('integrations-intro'),
      title: 'Work with what you have',
      description:
        'Integrations connect this site to systems you already run. Use the tabs below to switch between video management systems, camera import and analytics tools.',
      side: 'bottom',
    },
    {
      target: tag('integrations-how'),
      title: 'How it works',
      description: 'Three steps showing what happens when you connect an existing video management system to this site.',
      side: 'bottom',
    },
    {
      target: tag('integrations-connectors'),
      title: 'Pick a connector',
      description: 'Choose the system you use and fill in its connection details to bring its cameras into this site.',
      side: 'top',
    },
    {
      target: tag('integrations-custom'),
      title: 'Not on the list?',
      description: 'Use the custom option for any other system, or import cameras directly from a file.',
      side: 'top',
    },
  ],
};
